import { FC } from 'react'
// Comment until store data is sent
import { LayoutHeader } from './layout-components'
import { LayoutFooter } from './layout-components/layout-footer'
import { HeaderMobile } from './header-mobile'
import { BodyContent, LayoutContainer, LayoutMainContent, LayoutRightContent, LayoutBackground } from './layout.styled'
import { LayoutProps } from './layout.types'
import { StepProvider } from '../../context/layout-context'


export const Layout: FC<LayoutProps> = ({ children, rightContent, section }) => (
  <StepProvider>
    <LayoutBackground>
      <LayoutHeader />
      <LayoutContainer>
        <HeaderMobile />
        <LayoutMainContent>
          <BodyContent>
            {children}
          </BodyContent>
          <LayoutFooter />
        </LayoutMainContent>
        <LayoutRightContent>
          {rightContent}
        </LayoutRightContent>
      </LayoutContainer>
    </LayoutBackground>
  </StepProvider>
)
